import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/** Utils */
import { encryptRequest } from '../middleware/requestMiddleware';
import { getAuthProps } from '../../utils/authentication/authLibrary';

const { Mutex } = require('async-mutex');
const mutex = new Mutex();

const environment = process.env.REACT_APP_ENVIRONMENT;

const API_CONFIG = {
    production:    process.env.REACT_APP_LIVEURL,
    preproduction: process.env.REACT_APP_TESTURL,
    default:       process.env.REACT_APP_LOCALURL
};

const API_URL = API_CONFIG[environment] || API_CONFIG.default;

const baseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        headers.set('Content-Type', 'application/json');
        return headers;
    }
});

const fileBaseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => headers
});

export const defaultBaseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        headers.set('Content-Type', 'application/json');
        const authData = getAuthProps();
        if (authData?.token?.token) {
            headers.set('Authorization', `Bearer ${authData.token.token}`);
        }
        return headers;
    }
});

const executeWithAuth = async (args, api, extraOptions, queryInstance) => {
    const authData = getAuthProps();
    const token    = authData?.token?.token ?? null;

    if (!token) {
        window.location.href = '/login';
        return { error: { status: 401, data: 'Unauthorized' } };
    }
    await mutex.waitForUnlock();

    let modifiedArgs = encryptRequest(args);

    modifiedArgs = {
        ...modifiedArgs,
        headers: {
            ...(modifiedArgs.headers ?? {}),
            Authorization: `Bearer ${token}`
        }
    };

    const result = await queryInstance(modifiedArgs, api, extraOptions);

    if (result?.error?.status === 401) {
        window.location.href = '/login';
    }

    return result;
};

export const customFetchBase = (args, api, extraOptions) =>
    executeWithAuth(args, api, extraOptions, baseQuery);

export const customFileFetchBase = (args, api, extraOptions) =>
    executeWithAuth(args, api, extraOptions, fileBaseQuery);

export const encryptionOnlyBaseQuery = async (args, api, extraOptions) => {
    const modifiedArgs = encryptRequest(args);
    return defaultBaseQuery(modifiedArgs, api, extraOptions);
};